import React from 'react';

import style from './Fullscreen.css';

const getImage = isFullscreen => {
  if (isFullscreen) {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 20 20'>
        <g fill='none' fillRule='evenodd' transform='translate(-10 -10)'>
          <rect width='40' height='40' />
          <path
            stroke='white'
            strokeLinecap='round'
            strokeWidth='2'
            d='M23,11 L28,11 C28.5522847,11 29,11.4477153 29,12 L29,17'
            transform='matrix(0 1 1 0 12 -12)'
          />
          <path
            stroke='white'
            strokeLinecap='round'
            strokeWidth='2'
            d='M29,23 L29,28 C29,28.5522847 28.5522847,29 28,29 L23,29'
            transform='matrix(0 -1 -1 0 52 52)'
          />
          <path
            stroke='white'
            strokeLinecap='round'
            strokeWidth='2'
            d='M17,29 L12,29 C11.4477153,29 11,28.5522847 11,28 L11,23'
            transform='matrix(0 1 1 0 -12 12)'
          />
          <path
            stroke='white'
            strokeLinecap='round'
            strokeWidth='2'
            d='M11,17 L11,12 C11,11.4477153 11.4477153,11 12,11 L17,11'
            transform='matrix(0 -1 -1 0 28 28)'
          />
        </g>
      </svg>
    );
  }
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 20 20'>
      <g fill='none' fillRule='evenodd' transform='translate(-10 -10)'>
        <rect width='40' height='40' />
        <path
          stroke='white'
          strokeLinecap='round'
          strokeWidth='2'
          d='M23,11 L28,11 C28.5522847,11 29,11.4477153 29,12 L29,17 M29,23 L29,28 C29,28.5522847 28.5522847,29 28,29 L23,29 M17,29 L12,29 C11.4477153,29 11,28.5522847 11,28 L11,23 M11,17 L11,12 C11,11.4477153 11.4477153,11 12,11 L17,11'
        />
      </g>
    </svg>
  );
};
const Fullscreen = ({ isMobile, isFullscreen, hideFullscreenButton, setFullscreen }) => (
  // why is this not passed in the hideElements array?
  // We don't want this to be an api decision, this is based on if the player is loaded in an app or not
  <span
    className={!hideFullscreenButton ? `${isMobile ? style.mobile : ''} ${style.button}` : 'hide'}
    name={isFullscreen ? 'compress' : 'expand'}
    onClick={() => setFullscreen(!isFullscreen)}
  >
    {getImage(isFullscreen)}
  </span>
);

export default Fullscreen;
